/**
 * Generate a unique ID for a local entity
 * @param {string} entity - name of the entity
 * @returns {string}
 */
export default (entity = ''): string => `${entity}-${Date.now()}`;
 